module.exports = __webpack_public_path__ + "img/email-logo.9c752ffa.png";